import { keysToCamel } from '@helpers/camelCaseConverter';

/**
 * Converts success api response for consumption
 * @param response
 * @returns {*|Object}
 */
const successResponse = response => keysToCamel(response.data);

export default successResponse;
